var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toolbar-option',[_c('template',{slot:"primary"},[_c('select',_vm._b({},'select',_vm.value,false),[_c('option',{attrs:{"value":"paper"}},[_vm._v("Paper")])])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }